import { Component } from '@angular/core';
import { NavParams, PopoverController, ViewController, AlertController } from 'ionic-angular';

import { IMyDpOptions, IMyDateModel } from 'mydatepicker';

import { AlertService } from '../../../providers/alert-service';
import { ContratoService } from '../../../providers/contrato-service';
import { UsuarioService } from "../../../providers/usuario-service";
import { GestaoPcaService } from "../../../providers/gestao-pca-service";

import { PopoverAssinantesPage } from "../../popovers/popover-assinantes";
import { PopoverOptions } from "ionic-angular/components/popover/popover-options";

import { AGORA } from "../../../app/AGORA";
import { OpcoesAssinatura } from '../../../assinatura/opcoes-assinatura.model';
import { environment } from '../../../environments/environment';
import { ArquivosService } from '../../../providers/arquivos-service';


@Component({
  selector: 'page-modal-produto-contrato',
  templateUrl: 'modal-produto-contrato.html',
  providers: [
    AlertService,
    ContratoService,
    AGORA
  ]
})
export class ModalProdutoContratoPage {
  loading: boolean = true;
  PCAAtiva: any;
  usuarioLogado: any;
  cdModulo: any;
  idModuloPca: any;
  titulo: any;
  produtos: any = [];
  listaTiposProduto: any = [];
  listaAnosPlanoAcao: any[];
  removerProdutosList: any = [];
  aditivo: any;
  analistaEditar: any;
  idQuestaoReposta: any;
  planoAcoesAnteriores: any[];
  objetoRetorno: {
    flag: boolean,
    objeto: string
  };
  jurisdicionado: any;
  produtoParaAdicionar: any = {
    "id": "0",
    "descricao": "",
    "valor": "",
    "valorOriginal": "",
    "novaDataVigencia": "",
    "tipo": "",
    "idAditivo": ""
  }
  somaValorProdutos: any;
  listaArquivosAditivo: any = [];
  listaArquivosAditivoTermo: any = [];
  prorrogacao: any = false;
  prorrogacaoCheck: any = false;
  outros: any = false;
  count: any = 0;
  listaTipoDocumentos: any[] = null;
  analise: any = null;
  tipoEntidadeExercicio: any = null;
  tipoDocumento: any;
  listaArquivosPCA: any;
  idProcessoJustificativa: number = null;
  msgErro: string = "";
  IdProcesso: any = null;
  tipoAnalise: any = null;
  origemFilter: any;
  origemArquivo: any;
  listaPecasProcessuaisObrigatoria: any[];
  isJurisdicionado: any;
  isCGE: any;
  isSefaz: boolean;
  isModuloPeca: boolean = false;

  myDatePickerNovaVigenciaOptions: IMyDpOptions;

  opcoes: OpcoesAssinatura;

  constructor(
    public AGORA: AGORA,
    public popoverCtrl: PopoverController,
    private viewCtrl: ViewController,
    private alertService: AlertService,
    public navParams: NavParams,
    public contratoService: ContratoService,
    public alertCtrl: AlertController,
    public arquivoService: ArquivosService,
    public gestaoPcaService: GestaoPcaService,
    public usuarioService: UsuarioService) {

    this.usuarioLogado = this.usuarioService.obtemUsuario();
    this.PCAAtiva = this.gestaoPcaService.getPCA();

    this.cdModulo = 5;
    this.planoAcoesAnteriores = [];
    this.objetoRetorno = {
      flag: false,
      objeto: ""
    };

    this.resetarMyDatePickerNovaVigenciaOptions();

    this.titulo = this.navParams.get('param1');
    this.aditivo = this.navParams.get('aditivo');
    this.idModuloPca = this.navParams.get('idModuloPca');
    
    

    if (this.navParams.get('isModuloPeca') != undefined) {
      this.isModuloPeca = this.navParams.get('isModuloPeca');
    }

    if (this.navParams.get('idProcessoJustificativa') != undefined) {
      this.idProcessoJustificativa = this.navParams.get('idProcessoJustificativa');
    }

    this.isJurisdicionado = this.navParams.get('jurisdicionado');
    this.isCGE = this.navParams.get('isCGE');
    this.isSefaz = this.navParams.get('pFlSefaz');
     //console.log("FlSefaz - Modal: " + this.isSefaz);

    this.IdProcesso = this.navParams.get('IdProcesso');
    this.tipoAnalise = this.navParams.get('tipoAnalise');
    this.listaTipoDocumentos = this.navParams.get('listaTipoDocumentos');
    this.analise = this.navParams.get('analise');
    this.tipoEntidadeExercicio = this.navParams.get('tipoEntidadeExercicio');
    this.tipoDocumento = this.navParams.get('tipodocumento');

    this.origemFilter = this.navParams.get('origemFilter');

    if (this.navParams.get('origemArquivo') != undefined && this.navParams.get('origemArquivo') != null) {
      this.origemArquivo = this.navParams.get('origemArquivo');
    } else {
      this.origemArquivo = 'NA';
    }

    if (this.navParams.get('origemFilter') != undefined) {
      this.origemFilter = this.navParams.get('origemFilter');
    } else {
      this.origemFilter = null;
    }

    this.obterProdutosDoAditivo();
    this.obterListaTiposDeProduto();

    this.listarArquivosAditivo(this.aditivo);
    // this.listarArquivosAditivoTermo(this.aditivo);

    this.loading = false;
   // console.log("idprocesso: " +this.IdProcesso);
   //  console.log("idmodulopca: " +this.idModuloPca);
   //  console.log("tipoanalise: " +this.tipoAnalise);

    this.inicarOpcoesAssinatura();

  }

  obterProdutosDoAditivo() {
    this.contratoService.listarProdutosAditivo(this.aditivo.id).subscribe(data => {
      if (data != null) {

        this.produtos = data;

        if (this.aditivo.tipoAditivo == 'PRORROGAÇÃO') {
          this.prorrogacao = true;
          this.produtoParaAdicionar.tipo = 'Prorrogação';

          var pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
          this.produtoParaAdicionar.novaDataVigencia = new Date(this.aditivo.novaDataVigencia.replace(pattern, '$3-$2-$1')).toLocaleDateString('pt-br');

          this.count = 0;
          this.produtos.forEach(prod => {

            if (prod != undefined) {
              if ((prod.tipo == 'Prorrogação') && (prod.novaDataVigencia == this.produtoParaAdicionar.novaDataVigencia)) {
                this.count += 1;
              }
            }
          });

          if (this.count == 0) {
            this.adicionarProduto();
          }

          this.limparProdutoParaAdicionar();

        } else {
          this.prorrogacao = false;
        }
      }
    }, error => {
      console.log("erro: " + error);
    });
  }

  obterListaTiposDeProduto() {
    this.contratoService.listarTiposDeProduto().subscribe(data => {
      if (data != null) {

        for (var i = 0; i < data.length; i++) {
          if (data[i].toString() == '-') {
            data.splice(i, 1); // removes the matched element
            i = data.length;  // break out of the loop. Not strictly necessary
          }
        }

        this.listaTiposProduto = data;
      }
    }, error => {
      console.log("erro: " + error);
    });
  }

  dismiss() {
    this.viewCtrl.dismiss(this.objetoRetorno);
  }

  calculaLimiteLegalProduto(produto) {
    return this.contratoService.formatarPorcentagem(this.contratoService.calculaLimiteLegalProduto(produto));
  }

  salvarProdutos() {

    if(this.removerProdutosList.length > 0) {

      let totalProdutos = this.removerProdutosList.length;

      this.removerProdutosList.forEach((produto, index) => {

        this.contratoService.deletarProdutosDoAditivo(produto.id).subscribe(
          () => {
            if(index + 1 == totalProdutos) {
              this.salvar();
            }
          }, error => {
            console.log("Ocorreu um erro ao deletar o produto");
            console.log(error);
          }
        );
      });

      this.removerProdutosList = [];

    } else {
      this.salvar();
    }

  }

  salvar() {
    this.objetoRetorno.flag = true;
    this.contratoService.salvarProdutosDoAditivo(this.produtos).subscribe(
      () => {
          this.mostrarAlerta("", "Produtos salvos com sucesso!");
          this.viewCtrl.dismiss(this.objetoRetorno);
      }, error => {
        this.mostrarAlerta("Não foi possível salvar o termo do aditivo!", error.mensagem);
        console.log(error);
        this.viewCtrl.dismiss(this.objetoRetorno);
      });
  }

  mostrarAlerta(titulo, subtitulo) {
    let alert = this.alertCtrl.create({
      title: titulo,
      subTitle: subtitulo,
      buttons: ['Ok']
    });
    alert.present();
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  adicionarProduto() {

    if (this.produtoParaAdicionar.valor == null || this.produtoParaAdicionar.valor == undefined || this.produtoParaAdicionar.valor == '' || isNaN(this.produtoParaAdicionar.valor)) {
      this.produtoParaAdicionar.valor = 0;
    }

    if (this.produtoParaAdicionar.valorOriginal == null || this.produtoParaAdicionar.valorOriginal == undefined || this.produtoParaAdicionar.valorOriginal == '' || isNaN(this.produtoParaAdicionar.valorOriginal)) {
      this.produtoParaAdicionar.valorOriginal = 0;
    }

    if ((this.produtoParaAdicionar.tipo == "Prorrogação"
          && this.produtoParaAdicionar.novaDataVigencia != '')
          || this.produtoParaAdicionar.tipo == "Outros") {

      let produtoNovo = {
        "id": "0",
        "descricao": this.produtoParaAdicionar.descricao,
        "novaDataVigencia": this.produtoParaAdicionar.novaDataVigencia,
        "valor": this.produtoParaAdicionar.valor,
        "valorOriginal": this.produtoParaAdicionar.valorOriginal,
        "tipo": this.produtoParaAdicionar.tipo,
        "idAditivo": this.aditivo.id
      };
      this.produtos.push(produtoNovo);

    } else {

      if (this.produtoParaAdicionar.descricao != '' &&
          this.produtoParaAdicionar.valor != '' &&
          this.produtoParaAdicionar.valorOriginal != '' &&
          this.produtoParaAdicionar.tipo != '') {

        let produtoNovo = {
          "id": "0",
          "descricao": this.produtoParaAdicionar.descricao,
          "novaDataVigencia": '',
          "valor": this.produtoParaAdicionar.valor,
          "valorOriginal": this.produtoParaAdicionar.valorOriginal,
          "tipo": this.produtoParaAdicionar.tipo,
          "idAditivo": this.aditivo.id
        };
        this.produtos.push(produtoNovo);
      }

      this.resetarMyDatePickerNovaVigenciaOptions();

    }

    this.limparProdutoParaAdicionar();
  }

  removerProduto(produto, isDeleting: boolean) {
      produto.isDeleting = isDeleting;
      this.removerProdutosList.push(produto);
      let index = this.produtos.indexOf(produto);
      this.produtos.splice(index, 1);
  }

  editarProduto(produto) {
    this.produtoParaAdicionar.tipo = produto.tipo;
    this.produtoParaAdicionar.descricao = produto.descricao;
    this.produtoParaAdicionar.valor = produto.valor;
    this.produtoParaAdicionar.valorOriginal = produto.valorOriginal;
    this.produtoParaAdicionar.novaDataVigencia = produto.novaDataVigencia;

    this.removerProduto(produto, false);
  }

  onDataNovaVigenciaChanged(event: IMyDateModel) {
    if (event.formatted !== '') {
      this.produtoParaAdicionar.novaDataVigencia = new Date(event.jsdate).toLocaleDateString('pt-br');

      let copy = this.getCopyOfVigenciaOptions();

      copy.componentDisabled = false;
      copy.disableUntil = { year: event.date.year, month: event.date.month, day: event.date.day };

      this.myDatePickerNovaVigenciaOptions = copy;
    }
  }

  onSelectChanged(event) {
    if (event != "Prorrogação") {
      this.prorrogacaoCheck = false;
    } else {
      this.prorrogacaoCheck = true;
    }

    if (event == "Outros") {
      this.outros = true;
    } else {
      this.outros = false;
    }
  }

  getCopyOfVigenciaOptions(): IMyDpOptions {
    return JSON.parse(JSON.stringify(this.myDatePickerNovaVigenciaOptions));
  }

  fileChangeAditivo(event) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
      if (callback) {
        this.loading = true;
        this.contratoService.enviarTermoDeReferenciaAditivo(event, this.aditivo.id, this.idModuloPca).subscribe(data => {
          this.alertService.mostraAlerta("", "Arquivo importado com sucesso!");
          this.listarArquivosAditivo(this.aditivo);
          // this.listarArquivosAditivoTermo(this.aditivo);
        }, error => {
          this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error);
          console.log("erro: " + error);
        });
        this.loading = false;
      }
    });
  }

  baixarArquivo(idArquivoVinculado) {
    this.loading = true;
    this.contratoService.downloadTermoDeReferenciaContrato(idArquivoVinculado);
    this.loading = false;
  }

  deletarArquivo(arquivo) {
    this.alertService.mostraModalConfirmacao("Excluir Arquivo", "Você tem certeza que deseja excluir o arquivo " + arquivo.nmArquivo + "?",
      retornoModal => {
        if (retornoModal) {
          this.loading = true;
          this.contratoService.deletarTermoDeReferenciaContrato(arquivo.idArquivoVinculado).subscribe(data => {
            this.alertService.mostraAlerta("", "Arquivo excluído com sucesso.");
            this.listarArquivosAditivo(this.aditivo);
            // this.listarArquivosAditivoTermo(this.aditivo);
          }, (error) => {
            console.log("erro: " + error.mensagem);
            this.alertService.mostraAlerta("", "Houve um erro ao excluir arquivo." + error.mensagem);
          });

          this.loading = false;
        }
      }
    );
  }

  listarArquivosAditivo(aditivo) {
    this.contratoService.listarTermosDeReferencia(aditivo.id, this.idModuloPca, 0).subscribe(data => {
      this.listaArquivosAditivo = data;
      //this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.loading = false;
      this.alertService.mostraAlerta("", "Não foi possível listar os arquivos.");
    });
  }

  assinarArquivos(arquivo) {

    // Assinar arquivo
    let assinar = this.AGORA.assinarArquivos(arquivo.idArquivoVinculado, this.PCAAtiva.id, this.usuarioLogado.dadosUsuario[0].cpf,this.usuarioService.obterDadosUsuario().perfil);
    assinar.subscribe(
      next => {
        console.log('Sucesso: %s', next);
        this.dismiss();
      },
      error => {
        console.log('Erro: %s', error);
        this.alertService.mostraAlerta("Erro encontrado", error);
      });

  }

  exibirAssinantes(myEvent, assinantes) {

    let options: PopoverOptions = {
      cssClass: "popover-assinantes",
      showBackdrop: false,
      enableBackdropDismiss: false
    };

    let popover = this.popoverCtrl.create(PopoverAssinantesPage, { assinantes: assinantes }, options);
    popover.present({
      ev: myEvent
    });
  }

  limparProdutoParaAdicionar(){
    this.produtoParaAdicionar.descricao =
    this.produtoParaAdicionar.valor =
    this.produtoParaAdicionar.valorOriginal =
    this.produtoParaAdicionar.novaDataVigencia =
    this.produtoParaAdicionar.tipo = '';
  }

  resetarMyDatePickerNovaVigenciaOptions(){
    let copy = {
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
      dateFormat: 'dd/mm/yyyy',
      todayBtnTxt: 'Hoje',
      firstDayOfWeek: 'su',
      disableWeekends: false,
      editableDateField: true,
      openSelectorOnInputClick: true,
      showClearDateBtn: false
    };

    this.myDatePickerNovaVigenciaOptions = copy;
  }

  
  sucesso(evento: any) {
    this.carregarModal();
    this.inicarOpcoesAssinatura();
    // console.log(evento);
    // console.log('Assinatura realizada com sucesso.');
  }

  carregarModal() {
    this.listarArquivosAditivo(this.aditivo);
  }

 /* listarArquivosPCA() {
    if (this.listaTipoDocumentos != null && this.listaTipoDocumentos.length > 0) {

      this.arquivoService.listarArquivosVinculadosPorModuloPcaPorTipoDocumento(this.idModuloPca, this.listaTipoDocumentos, this.isSefaz).subscribe(data => {
        if (this.tipoEntidadeExercicio != undefined && this.tipoEntidadeExercicio != 0) {
          if (!this.idProcessoJustificativa) {
            this.listaArquivosPCA = data.filter((arquivo) => arquivo.peca.idTipoEntidadeExercicio == this.tipoEntidadeExercicio);
          } else {
            this.listaArquivosPCA = data.filter((arquivo) => arquivo.peca.idTipoEntidadeExercicio == this.tipoEntidadeExercicio && arquivo.idProcesso != this.idProcessoJustificativa);
          }
        } else {
          this.listaArquivosPCA = data;
        }
        this.loading = false;
      },  error  => {
        this.loading = false;
        this.msgErro = "Ocorreu um erro ao listar os arquivos: " + error.mensagem;
        this.alertService.mostraAlerta("", this.msgErro); 
      });

    } else {
      this.arquivoService.listarPecasVinculadasPCA(this.IdProcesso, this.idModuloPca, this.tipoAnalise).subscribe(data => {
        if (this.tipoEntidadeExercicio != undefined && this.tipoEntidadeExercicio != 0) {
          this.listaArquivosPCA = data.filter((arquivo) => arquivo.peca.idTipoEntidadeExercicio == this.tipoEntidadeExercicio);
        } else {
          this.listaArquivosPCA = data;
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        this.alertService.mostraAlerta("", "Ocorreu um erro ao listar os arquivos:" + error);
      });
    }

    this.arquivoService.listarPecasProcessuaisObrigatoria(this.idModuloPca).subscribe(data => {
      this.listaPecasProcessuaisObrigatoria = data;

      this.arquivoService.listarPecasProcessuaisNObrigatoria(this.idModuloPca).subscribe(data2 => {

        if (data2.length > 0) {
          this.listaPecasProcessuaisObrigatoria.push(data2);
        }

        if (this.origemFilter != null) {
          let testFilter = this.listaPecasProcessuaisObrigatoria.filter((tipo) => tipo.nmTipoDocumento == this.origemFilter)[0];

          if (testFilter != undefined) {
            this.tipoDocumento = testFilter;
          }
        }

        if (this.isJurisdicionado && !this.isCGE) {
          if ((<HTMLInputElement>document.getElementById("file"))) {
            if (this.tipoAnalise == '0' || this.tipoDocumento != null || this.tipoDocumento != undefined || this.tipoDocumento != '') {
              if (this.tipoDocumento == 45 && this.isModuloPeca == true) {
                (<HTMLInputElement>document.getElementById("file")).disabled = true;
                // console.log("1");
              } else {
                (<HTMLInputElement>document.getElementById("file")).disabled = false;
                // console.log("2");
              }
            } else {
              if (this.tipoDocumento == 45 && this.isModuloPeca == true) {
                (<HTMLInputElement>document.getElementById("file")).disabled = true;
                // console.log("3");
              } else {
                (<HTMLInputElement>document.getElementById("file")).disabled = false;
                // console.log("4");
              }
            }
          }
        }
      }, error => console.log("erro: " + error));

    }, error => console.log("erro: " + error));
    
  }*/

  isAbilitarBotaoAssinatura() {
    return this.opcoes.arquivos.length > 0;
  }

  inicarOpcoesAssinatura() {

    const cpf = environment.production ? this.usuarioLogado.dadosUsuario[0].cpf : environment.cpfAssinateTeste;

    this.opcoes = {
      arquivos: [],
      cpfUsuarioLogado: cpf,
      urlBackEndCallBack: environment.urlBackEndCallBackAssinatura,
      dadosBackEndCallBack: [],
      idPca: this.PCAAtiva.id,
      tipoArquivo: 'TIPO_VINCULADO'
    };
  }

  marcarArquivoParaAssinar(evento: any, arquivo: any) {

    if (evento.checked) {
      this.incluirArquivoNasOpcoesAssinatura(arquivo.pathArquivo);
      this.incluirArquivoNosDadosDoCallBackAssinatura(arquivo);
    } else {
      this.removerArquivoDasOpcoesAssinatura(arquivo.pathArquivo);
      this.removerArquivoDosDadosDoCallBackAssinatura(arquivo);
    }
}

private incluirArquivoNasOpcoesAssinatura(caminho: string) {
 //console.log(caminho);
  this.opcoes.arquivos.push(caminho);
}
private removerArquivoDasOpcoesAssinatura(caminho: string) {
  this.opcoes.arquivos = this.opcoes.arquivos.filter(c => {
    return caminho !== c;
  });
}

private incluirArquivoNosDadosDoCallBackAssinatura(arquivo: any) {
  this.opcoes.dadosBackEndCallBack.push({
    idPca: this.PCAAtiva.id,
    idDocumento: arquivo.idArquivoVinculado,
    cpfAssinante: this.formatarCpf(this.usuarioLogado.dadosUsuario[0].cpf),
    perfil: this.usuarioService.obterDadosUsuario().perfil
  });
}
private removerArquivoDosDadosDoCallBackAssinatura(arquivo: any) {
  this.opcoes.dadosBackEndCallBack = this.opcoes.dadosBackEndCallBack.filter(a => {
    return a.idDocumento !== arquivo.idArquivoVinculado;
  });
}

private formatarCpf(valor) {
  return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
}

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-produto-contrato/modal-produto-contrato.ts